export default __webpack_public_path__ + "static/media/Icon_feather-download.a42a37e0.svg";